import {Link} from "react-router-dom";

const Header = () => (
    <header className="header">
        <nav className="header__nav">
            <Link to="/projects" className="header__link">Projects</Link>
            <Link to="/products" className="header__link">Products</Link>
            <Link to="/services" className="header__link">Services</Link>
        </nav>
        <Link to="/" className="header__logo">
            <img src="/logo-white.svg" className="logo" alt="Neongod Logo"/>
        </Link>
        <nav className="header__nav">
            <Link to="/about" className="header__link">About</Link>
            <Link to="/partners" className="header__link">Partners</Link>
            <Link to="/contact" className="header__link">Contact</Link>
        </nav>
    </header>

)

export default Header;